import youCanCloseImg from '@/assets/images/you-can-close-the-modal.webp';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

type BackgroundWorkNoticeProps = {
    /** What is still running and what it unlocks — the only line that varies. */
    description: ReactNode;
    title?: string;
    className?: string;
};

/**
 * The "this keeps going without you" screen: art, one heading, one sentence.
 *
 * The heading is the same in every host on purpose — a background job the user
 * may walk away from is one concept, and this is the only reference to the
 * asset, so swapping the illustration is a one-line change here.
 */
export function BackgroundWorkNotice({
    description,
    title = 'Pode fechar esta janela',
    className,
}: BackgroundWorkNoticeProps) {
    return (
        <div className={cn('flex flex-col items-center gap-4 pt-2 text-center', className)}>
            <img
                src={youCanCloseImg}
                alt=""
                // Intrinsic size, so the modal reserves the box instead of
                // reflowing when the art lands.
                width={862}
                height={753}
                decoding="async"
                className="h-32 w-auto object-contain sm:h-40"
            />
            <div className="space-y-2">
                <h3 className="text-base font-semibold text-foreground">{title}</h3>
                <p className="mx-auto max-w-md text-sm leading-5 text-muted-foreground">
                    {description}
                </p>
            </div>
        </div>
    );
}
